export const SHOW_GENERAL_EDIT_FORM_EVENT = "show-general-edit-form-event";
export const SHOW_DIRECTION_CONTACT_EDIT_FORM_EVENT = "show-direction-contact-edit-form-event";
export const SHOW_PERSONAL_EDIT_FORM_EVENT = "show-personal-edit-form-event";
export const SHOW_PAYMENT_EDIT_FORM_EVENT = "show-payment-edit-form-event";
export const PROFILE_DATA_UPDATED_EVENT = "profile-data-updated-event";
